import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { SettingsView } from "./views/SettingsView";
import { SettingsController } from "../../../common/controllers/SettingsController";
import { SettingsResourcesPackage } from "./resources/SettingsResourcesPackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { SettingsModel } from "../../../common/models/SettingsModel";
import { LocalizationModel } from "../../../common/models/LocalizationModel";

@injectable()
export class SettingsScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        settingsResources: SettingsResourcesPackage,
        settingsModel: SettingsModel,
        localizationModel: LocalizationModel,
        settingsController: SettingsController,
        @inject(InjectableInterfaces.ICanvasScaler) canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new SettingsView(
            settingsController,
            commonResources,
            settingsResources,
            settingsModel,
            localizationModel,
            canvasScaler,
            pcs
        );
        pcs.result.then(
            () => this.operationControls.complete(),
            (reason: unknown) => this.operationControls.error(reason)
        );
    }
}
